import { TzadikimModel } from "./tz.model";
import { CityModel } from "./city.model";
import { CategoryModel } from "./category.model";


export class MkmModel {
    id!: number;
    poi!: string;
    mkmTitle!: string;
    info!: string;
    sInfo!: string;
    streetNumber!: string;
    streetName!: string;
    areaLevel!: string;
    mkmImages!:string;
    cityId!: number;
    city: CityModel;
    categoryId!: number;
    category!: CategoryModel;
    tz: TzadikimModel[];
    cohanPlace!:string;

    constructor() {
        this.tz = new Array<TzadikimModel>();
        this.city = new CityModel();
    }
}

